import type { BulkInviteSuccessResponse, InviteApiSuccessResponse } from './data-types';

export const handleInviteUsersSuccessResponse = (
	response: InviteApiSuccessResponse[],
): BulkInviteSuccessResponse =>
	response.reduce<BulkInviteSuccessResponse>(
		(accumulator, userResponse) => {
			const user = {
				id: userResponse.id,
				email: userResponse.email,
			};

			Object.keys(userResponse.results).forEach((resource) => {
				switch (userResponse.results[resource]) {
					case 'INVITED':
					case 'USER_EXISTS':
						accumulator.invited.push({
							...user,
							results: userResponse.results,
						});
						break;
					case 'INVITED_PENDING_APPROVAL':
					case 'PENDING_INVITE_EXISTS':
						accumulator.accessRequested.push({
							...user,
							results: userResponse.results,
						});
						break;
					case 'NOT_INVITED':
					case 'ERROR':
						accumulator.error.push({
							...user,
							error: userResponse.errorReasons[resource],
						});
						break;
					default:
						throw new Error('Unexpected return type from invite user response');
				}
			});
			return accumulator;
		},
		{
			invited: [],
			accessRequested: [],
			error: [],
		},
	);

export const getSiteAri = (tenantId: string, product: string) =>
	`ari:cloud:${product}::site/${tenantId}`;
